"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Splits9 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_slick_1 = __importDefault(require("react-slick"));
var icons_1 = require("../../../icons");
var Split_1 = require("../../bricks/Split");
var Splits9 = function (_a) {
    var image = _a.image, channel = _a.channel, videoId = _a.videoId, url = _a.url, slides = _a.slides;
    var sliderRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(0), activeIndex = _b[0], setActiveIndex = _b[1];
    var _c = (0, react_1.useState)(false), isAnimating = _c[0], setIsAnimating = _c[1];
    var prev = function (e) {
        e.preventDefault();
        if (isAnimating)
            return;
        var prevIndex = activeIndex === 0 ? slides.length - 1 : activeIndex - 1;
        setActiveIndex(prevIndex);
        sliderRef.current.slickPrev();
    };
    var next = function (e) {
        e.preventDefault();
        if (isAnimating)
            return;
        var nextIndex = activeIndex === slides.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
        sliderRef.current.slickNext();
    };
    var settings = {
        dots: false,
        arrows: false,
        speed: 600,
        draggable: false,
        beforeChange: function () { return setIsAnimating(true); },
        afterChange: function () { return setIsAnimating(false); },
    };
    return ((0, jsx_runtime_1.jsxs)(Split_1.Split, __assign({ textSide: "right", textWidth: "lg", invertedPlay: true, playSize: "xl", bgImage: image, channel: channel, videoId: videoId, url: url }, { children: [(0, jsx_runtime_1.jsx)(react_slick_1.default, __assign({ ref: sliderRef }, settings, { children: slides.map(function (item, index) { return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "d-flex align-items-center mb-8" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "flex-shrink-0" }, { children: (0, jsx_runtime_1.jsx)("img", { src: item.image, className: "rounded-circle", alt: "" }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex-grow-1 ms-6" }, { children: [(0, jsx_runtime_1.jsx)("h2", __assign({ className: "h5 mb-2" }, { children: item.name })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "fw-light opacity-80" }, { children: item.title }))] }))] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "h4 lh-1-5" }, { children: [(0, jsx_runtime_1.jsxs)("p", __assign({ className: "opacity-100 mb-5" }, { children: ["\u201C", item.paragraph1, "\u201D"] })), (0, jsx_runtime_1.jsxs)("p", __assign({ className: "opacity-100 mb-9" }, { children: ["\u201C", item.paragraph2, "\u201D"] }))] }))] }, index)); }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "d-flex align-items-center" }, { children: [(0, jsx_runtime_1.jsx)("a", __assign({ href: "#", className: "text-default", onClick: prev }, { children: (0, jsx_runtime_1.jsx)(icons_1.TailLeft32, {}) })), (0, jsx_runtime_1.jsxs)("span", __assign({ className: "mx-5" }, { children: [activeIndex + 1, " / ", slides.length] })), (0, jsx_runtime_1.jsx)("a", __assign({ href: "#", className: "text-default", onClick: next }, { children: (0, jsx_runtime_1.jsx)(icons_1.TailRight32, {}) }))] }))] })));
};
exports.Splits9 = Splits9;
